import { TabPageDefinition } from '@/components/tab-pages.js';
import { coachAvailabilityTypeSchema, CoachAvailabilityType } from '@airreading/common/data';
import { AlertCircle } from 'lucide-react';
import { z } from 'zod';

export const myAvailabilitySearchSchema = z.object({
  schedule: coachAvailabilityTypeSchema.optional().default(CoachAvailabilityType.regular),
});

export type MyAvailabilitySearch = z.infer<typeof myAvailabilitySearchSchema>;

export function myAvailabilityTabs(
  schedule: MyAvailabilitySearch['schedule'],
  substituteTeachingAvailability: boolean,
): TabPageDefinition[] {
  return [
    {
      label: 'Regular schedule',
      linkProps: {
        to: '/my-availability',
        search: { schedule: CoachAvailabilityType.regular },
      },
      isSelectedTab: schedule === CoachAvailabilityType.regular,
      dataTestId: 'my-availability-weekly-hours-tab-regular',
    },
    {
      label: 'Substitute teaching',
      ...(!substituteTeachingAvailability ? { iconComponent: AlertCircle, iconPosition: 'right' as const } : {}),
      linkProps: {
        to: '/my-availability',
        search: { schedule: CoachAvailabilityType.substitute },
      },
      isSelectedTab: schedule === CoachAvailabilityType.substitute,
      dataTestId: 'my-availability-weekly-hours-tab-substitute',
    },
  ];
}
